import React, { useEffect } from 'react';
import ReactPaginate from 'react-paginate';
import c from 'classnames';
import './style.scss';
import PropTypes from 'prop-types';
import withMapping from '../../Context/withMapping';
export var Pagination = function Pagination(_ref) {
  var currentPage = _ref.currentPage,
    totalPages = _ref.totalPages,
    pageRangeDisplayed = _ref.pageRangeDisplayed,
    marginPagesDisplayed = _ref.marginPagesDisplayed,
    setCurrentPage = _ref.setCurrentPage,
    previousLabel = _ref.previousLabel,
    nextLabel = _ref.nextLabel,
    containerClassName = _ref.containerClassName,
    disabledClassName = _ref.disabledClassName,
    activeClassName = _ref.activeClassName,
    breakClassName = _ref.breakClassName,
    showWhenOnePage = _ref.showWhenOnePage,
    controlled = _ref.controlled,
    scrollToTop = _ref.scrollToTop,
    scrollToTopOffset = _ref.scrollToTopOffset,
    scrollToTopBehavior = _ref.scrollToTopBehavior;
  useEffect(function () {
    if (scrollToTop) {
      window.scrollTo({
        top: scrollToTopOffset,
        behavior: scrollToTopBehavior
      });
    }
  }, [currentPage]);
  var pageChange = function pageChange(data) {
    if (setCurrentPage && typeof data.selected === 'number') {
      setCurrentPage(data.selected + 1);
    }
  };
  if (totalPages === 0) {
    return null;
  }
  if (totalPages === 1 && !showWhenOnePage) {
    return null;
  }
  if (currentPage > totalPages) {
    currentPage = totalPages;
  }
  if (!previousLabel || !nextLabel) {
    previousLabel = /*#__PURE__*/React.createElement("a", {
      className: "Pagination__previous__icon"
    });
    nextLabel = /*#__PURE__*/React.createElement("a", {
      className: "Pagination__next__icon"
    });
  }
  var containerClasses = c('Pagination__container', containerClassName);
  var breakClasses = c('Pagination__break', breakClassName);
  var disabledClasses = c('disabled', disabledClassName);
  var activeClasses = c('active', activeClassName);
  return /*#__PURE__*/React.createElement("div", {
    className: "Pagination"
  }, /*#__PURE__*/React.createElement(ReactPaginate, {
    previousLabel: previousLabel,
    nextLabel: nextLabel,
    breakLabel: "...",
    breakClassName: breakClasses,
    pageCount: totalPages,
    pageRangeDisplayed: pageRangeDisplayed,
    marginPagesDisplayed: marginPagesDisplayed,
    disabledClassName: disabledClasses,
    initialPage: !controlled && currentPage - 1,
    forcePage: controlled && currentPage - 1,
    onPageChange: pageChange,
    containerClassName: containerClasses,
    activeClassName: activeClasses
  }));
};
Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  pageRangeDisplayed: PropTypes.number,
  marginPagesDisplayed: PropTypes.number,
  setCurrentPage: PropTypes.func,
  previousLabel: PropTypes.string,
  nextLabel: PropTypes.string,
  containerClassName: PropTypes.string,
  disabledClassName: PropTypes.string,
  activeClassName: PropTypes.string,
  showWhenOnePage: PropTypes.bool,
  controlled: PropTypes.bool,
  scrollToTop: PropTypes.bool,
  scrollToTopOffset: PropTypes.number,
  scrollToTopBehavior: PropTypes.oneOf(['smooth', 'instant', 'auto'])
};
Pagination.defaultProps = {
  setCurrentPage: null,
  previousLabel: null,
  nextLabel: null,
  containerClassName: null,
  disabledClassName: null,
  activeClassName: null,
  pageRangeDisplayed: 5,
  marginPagesDisplayed: 1,
  showWhenOnePage: false,
  controlled: false,
  scrollToTop: false,
  scrollToTopOffset: 0,
  scrollToTopBehavior: 'smooth'
};
export default withMapping(Pagination);